export default {
  title: 'Votre projet d\'investissement',
  fillInformationsSection: {
    title: 'Complétez les informations',
    scheduledContributionsSubSection: {
      title: 'Vos versements',
      description:
        'Configurer vos versements à effectuer lors de cette opération',
      inputLabel: 'Versements programmés',
      inputPlaceholder: 'Saisissez un montant mensuel',
      inputError: {
        valueTooMuch: 'La capacité d\'épargne disponible est de {amount}',
      },
    },
    investmentHorizonSubSection: {
      title: 'Horizon d\'investissement',
      description: 'Définir un horizon d\'investissement pour cette opération',
      inputLabel: 'Horizon d\'investissement',
      inputPlaceholder: 'Sélectionnez un horizon d\'investissement',
    },
    investmentGoalSubSection: {
      title: 'Objectif de ce placement',
      description: 'Préciser l\'objectif de ce placement associé à ce placement',
      inputLabel: 'Objectif du placement',
      inputPlaceholder: 'Sélectionnez un objectif',
      optionLabels: {
        futurePreparation: `Préparer son avenir (études, permis de conduire, première installation...)`,
        regularIncome: 'Percevoir des revenus réguliers',
        diversification: 'Diversifier son patrimoine',
        placement: 'Faire un placement',
      },
      goalLabels: {
        futurePreparation: `de préparer son avenir (études, permis de conduire, première installation...)`,
        regularIncome: 'de percevoir des revenus réguliers',
        diversification: 'de diversifier son patrimoine',
        placement: 'de faire un placement',
      },
    },
    footerHelpText:
      'Les choix suivants vont permettre d\'affiner notre préconisation financière',
  },
  esgPreferencesSection: {
    investorProfileSubSection: {
      title: 'Profil investisseur',
      description: 'Définir le profil investisseur à retenir pour ce conseil',
      inputLabel: 'Profil investisseur',
      inputPlaceholder: 'Sélectionner',
    },
  },
}
